// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".internal-result-sidebar1 .b-sidebar {\n  height: 70vh;\n}\n.internal-result-sidebar2 .b-sidebar {\n  height: 50vh;\n}\n.sidebar-btn {\n  position: fixed;\n  z-index: 8000;\n  opacity: 0.8;\n}\n.sidebar-btn:hover {\n  right: 0px;\n  -webkit-transition: 0.5;\n  transition: 0.5;\n}\n.sidebar-btn:not(.sidebar-close-btn, .sidebar-show-btn):hover {\n  right: 0px !important;\n  -webkit-transition: 0.5 !important;\n  transition: 0.5 !important;\n}", ""]);
// Exports
module.exports = exports;
